import { render, staticRenderFns } from "./webDiscountCharge.vue?vue&type=template&id=18f3a128&"
import script from "./webDiscountCharge.vue?vue&type=script&lang=js&"
export * from "./webDiscountCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports